export default __webpack_public_path__ + "static/media/GMM-Mani.bf8e598a.webp";